import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";

const rup = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function PurchaseVoucher() {
  const { pid } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    Promise.all([api.get(`/admin/purchases/${pid}`)])
      .then(([r]) => { setData({ p: r.data.purchase, biz: r.data.business }); setTimeout(() => window.print(), 600); })
      .catch(() => setData(false));
  }, [pid]);
  if (data === false) return <div style={{ padding: 40, fontFamily: "Arial" }}>Purchase not found.</div>;
  if (!data) return <div style={{ padding: 40, fontFamily: "Arial" }}>Loading…</div>;
  const { p, biz } = data;
  const items = p.items || [];

  return (
    <div style={{ fontFamily: "Arial, sans-serif", color: "#111", background: "#f1f5f9", minHeight: "100vh", padding: 16 }} data-testid="purchase-voucher">
      <style>{`@media print{.no-print{display:none!important}body{background:#fff}.sheet{box-shadow:none!important}} .sheet{background:#fff;width:760px;margin:0 auto;padding:28px 32px;box-shadow:0 1px 6px rgba(0,0,0,.12)} table{border-collapse:collapse;width:100%} th,td{border:1px solid #cbd5e1;padding:7px 9px;font-size:12px;text-align:left} th{background:#f1f5f9}`}</style>
      <div className="no-print" style={{ width: 760, margin: "0 auto 12px", textAlign: "right" }}>
        <button onClick={() => window.print()} style={{ padding: "8px 16px", background: "#0B8E36", color: "#fff", border: "none", borderRadius: 8, fontWeight: 700, cursor: "pointer" }}>Print / Save PDF</button>
      </div>
      <div className="sheet">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: 20 }}>{biz.name}</div>
            {biz.address && <div style={{ fontSize: 12, color: "#475569" }}>{biz.address}{biz.city ? `, ${biz.city}` : ""}</div>}
            {biz.gstin && <div style={{ fontSize: 12, color: "#475569" }}>GSTIN: {biz.gstin}</div>}
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontWeight: 800, fontSize: 16 }}>PURCHASE VOUCHER</div>
            <div style={{ fontSize: 12 }}>No: <b>{p.invoice_no || p.id}</b></div>
            <div style={{ fontSize: 12 }}>{new Date(p.created_at).toLocaleString("en-IN")}</div>
          </div>
        </div>
        <div style={{ fontSize: 12, marginBottom: 8 }}><b>Supplier:</b> {p.supplier_name}</div>
        <table>
          <thead><tr><th>#</th><th>Item</th><th style={{ textAlign: "right" }}>Qty</th><th style={{ textAlign: "right" }}>Cost</th><th style={{ textAlign: "right" }}>Amount</th></tr></thead>
          <tbody>
            {items.map((i, x) => (
              <tr key={`${i.product_id || i.name}-${x}`}><td>{x + 1}</td><td>{i.name || i.product_id}</td><td style={{ textAlign: "right" }}>{i.quantity}</td><td style={{ textAlign: "right" }}>{rup(i.cost_price)}</td><td style={{ textAlign: "right" }}>{rup(i.quantity * i.cost_price)}</td></tr>
            ))}
          </tbody>
        </table>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
          <div style={{ fontWeight: 800, fontSize: 16 }}>Total: {rup(p.total)}</div>
        </div>
        <p style={{ textAlign: "center", fontSize: 12, marginTop: 28, color: "#475569" }}>Goods received & recorded in stock · {biz.footer_note}</p>
      </div>
    </div>
  );
}
